import React, {FC, useState} from 'react';

import {useInitialEffect} from '../../../../libs/shared/core/src/helpers/react/hooks/useEffectHelpers';
import {
  OnboardingEventsEnum,
  trackEvent,
  TrackingTypesEnum,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {OnboardingVideoSlide} from '../../onboarding/welcome/onboardingVideoSlide';
import {CarouselSlideContentProps, CarouselSlideDefinition} from '../carouselCommon';

/*
 * Props.
 */

interface WelcomeCarouselVideoComponentProps {
  onNextClick: () => void;
  totalStepCount?: number;
}

/*
 * Component.
 */

const WelcomeCarouselVideoComponent: FC<WelcomeCarouselVideoComponentProps> = ({
  onNextClick,
  totalStepCount,
}) => {
  const [hasPlayedVideo, setHasPlayedVideo] = useState(false);
  const [videoDuration, setVideoDuration] = useState(0);

  useInitialEffect(() => {
    trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.STARTED);
    trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.STARTED_VIDEO);
  });

  return (
    <OnboardingVideoSlide
      onNext={() => {
        trackEvent(TrackingTypesEnum.ONBOARDING_STEP, OnboardingEventsEnum.COMPLETED_VIDEO);

        onNextClick();
      }}
      setHasPlayedVideo={setHasPlayedVideo}
      hasPlayedVideo={hasPlayedVideo}
      videoDuration={videoDuration}
      setVideoDuration={setVideoDuration}
      stepNumber={1}
      totalStepCount={totalStepCount}
    />
  );
};

/*
 * Helpers.
 */

function renderContent(props: CarouselSlideContentProps) {
  const {index, totalStepCount} = props;
  return (
    <WelcomeCarouselVideoComponent
      onNextClick={props.onNextClick}
      key={index}
      totalStepCount={totalStepCount}
    />
  );
}

/*
 * Slide definition.
 */

export const welcomeCarouselVideoSlide: CarouselSlideDefinition = {
  renderContent,
};
